// Advanced stats of a shot: the groups, their options and what each one means, so every operator picks the same
// thing for the same play. `value` is what the backend stores (a stable code for the exports): change the labels
// and definitions freely, never the values.
export const SHOT_DETAIL_GROUPS = [
    {
        key: 'situation',
        title: 'Situation',
        subtitle: 'Τύπος επίθεσης',
        options: [
            { value: 'SET', label: 'Set', hint: 'Οργανωμένη', definition: 'Η άμυνα έχει στηθεί και η επίθεση παίζει οργανωμένα.' },
            { value: 'FASTBREAK', label: 'Fastbreak', hint: 'Αιφνιδιασμός', definition: 'Γρήγορη επίθεση με αριθμητικό πλεονέκτημα (π.χ. 2 εναντίον 1) πριν γυρίσει η άμυνα.' },
            { value: 'TRANSITION', label: 'Transition', hint: 'Ημι-αιφνιδιασμός', definition: 'Γρήγορη επίθεση χωρίς αριθμητικό πλεονέκτημα, πριν στηθεί πλήρως η άμυνα.' },
            { value: 'SECOND_CHANCE', label: 'Second chance', hint: 'Επιθ. ριμπάουντ', definition: 'Στην ίδια κατοχή, μετά από επιθετικό ριμπάουντ.' },
            { value: 'ATO', label: 'ATO', hint: 'Μετά από time-out / inbound', definition: 'Συστημένο παιχνίδι αμέσως μετά από time-out ή πλάγιο / τελικό άουτ.' }
        ]
    },
    {
        key: 'playType',
        title: 'Play type',
        subtitle: 'Τύπος δράσης',
        options: [
            { value: 'PICK_AND_ROLL', label: 'Pick & Roll', hint: '', definition: 'Σκριν στον χειριστή και ο σκρίνερ κόβει προς το καλάθι. Ρόλος: Ball handler αν σουτάρει ο χειριστής, Screener αν σουτάρει ο σκρίνερ.' },
            { value: 'PICK_AND_POP', label: 'Pick & Pop', hint: '', definition: 'Σκριν στον χειριστή και ο σκρίνερ ανοίγει για σουτ μακριά από το καλάθι.' },
            { value: 'SHORT_ROLL', label: 'Short roll', hint: '', definition: 'Ο σκρίνερ παίρνει την μπάλα στη μέση απόσταση (γύρω από τις βολές) μετά το σκριν και τελειώνει ο ίδιος.' },
            { value: 'DRIVE', label: 'Drive / Isolation', hint: 'Διείσδυση', definition: 'Ο παίκτης δημιουργεί μόνος του, ένας εναντίον ενός, χωρίς σκριν.' },
            { value: 'POST_UP', label: 'Post up', hint: 'Παιχνίδι με πλάτη', definition: 'Ο παίκτης παίρνει την μπάλα κοντά στο καλάθι με πλάτη στον αμυντικό.' },
            { value: 'HAND_OFF', label: 'Hand-off (DHO)', hint: 'Χέρι με χέρι', definition: 'Παίρνει την μπάλα χέρι με χέρι από συμπαίκτη που λειτουργεί και ως σκριν.' },
            { value: 'CUT', label: 'Cut', hint: 'Κόψιμο στη ρακέτα', definition: 'Κίνηση χωρίς μπάλα προς το καλάθι και πάσα (π.χ. backdoor).' },
            { value: 'OFF_SCREEN', label: 'Off-screen', hint: 'Σκριν μακριά από την μπάλα', definition: 'Ο σουτέρ βγαίνει από σκριν που του έγινε μακριά από την μπάλα και παίρνει πάσα.' },
            { value: 'SPOT_UP', label: 'Spot-up', hint: 'Υποδοχή & σουτ', definition: 'Περιμένει στατικός, παίρνει πάσα και σουτάρει ή επιτίθεται αμέσως (π.χ. μετά από kick-out).' }
        ]
    },
    {
        key: 'playerRole',
        title: 'Player role',
        subtitle: 'Ρόλος εκτελεστή',
        options: [
            { value: 'BALL_HANDLER', label: 'Ball handler', hint: 'Χειριστής', definition: 'Είχε την μπάλα και δημιούργησε ο ίδιος το σουτ (π.χ. ο χειριστής στο pick & roll).' },
            { value: 'SCREENER', label: 'Screener', hint: 'Σκρίνερ', definition: 'Έκανε το σκριν και σούταρε μετά (roll, pop ή short roll).' },
            { value: 'SPOT_UP', label: 'Spot-up player', hint: 'Στατικός', definition: 'Περίμενε στατικός την πάσα.' },
            { value: 'CUTTER', label: 'Cutter', hint: 'Κόψιμο χωρίς μπάλα', definition: 'Σκόραρε ή σούταρε μετά από κίνηση χωρίς μπάλα.' },
            { value: 'OFF_SCREEN_SHOOTER', label: 'Off-screen shooter', hint: '', definition: 'Βγήκε από σκριν μακριά από την μπάλα και σούταρε.' },
            { value: 'POST_PLAYER', label: 'Post player', hint: '', definition: 'Έπαιξε με πλάτη κοντά στο καλάθι.' },
            { value: 'REBOUNDER', label: 'Rebounder', hint: 'Ριμπάουντερ', definition: 'Πήρε το επιθετικό ριμπάουντ και σούταρε (π.χ. putback).' }
        ]
    },
    {
        key: 'shotType',
        title: 'Shot type',
        subtitle: 'Τρόπος εκτέλεσης',
        options: [
            { value: 'LAYUP', label: 'Layup / Rim finish', hint: '', definition: 'Τελείωμα δίπλα στο καλάθι (λέι απ, ρεβέρ κ.λπ.).' },
            { value: 'FLOATER', label: 'Float / Runner', hint: '', definition: 'Ψηλό, μαλακό σουτ σε κίνηση από μικρή ή μεσαία απόσταση, πάνω από ψηλό αμυντικό.' },
            { value: 'DUNK', label: 'Dunk', hint: 'Κάρφωμα', definition: 'Κάρφωμα.' },
            { value: 'CATCH_AND_SHOOT', label: 'Catch & shoot', hint: '2pt / 3pt', definition: 'Σουτ αμέσως μόλις πήρε την πάσα, χωρίς ντρίμπλα.' },
            { value: 'PULL_UP', label: 'Pull-up / Step-back', hint: 'Mid / 3pt', definition: 'Σουτ μετά από ντρίμπλα, από μέση απόσταση ή τρίποντο.' },
            { value: 'HOOK', label: 'Hook shot', hint: '', definition: 'Σουτ γάντζος, συνήθως από ψηλό κοντά στο καλάθι.' },
            { value: 'POST_MOVE', label: 'Up & under / Post move', hint: '', definition: 'Τελείωμα μετά από κίνηση με πλάτη (προσποίηση, up & under, spin).' },
            { value: 'PUTBACK', label: 'Tip-in / Putback', hint: '', definition: 'Τελείωμα αμέσως μετά από επιθετικό ριμπάουντ, χωρίς να στηθεί ξανά η επίθεση.' }
        ]
    }
]

export const SHOT_DETAIL_KEYS = SHOT_DETAIL_GROUPS.map(group => group.key)

export function emptyShotDetails() {
    return SHOT_DETAIL_KEYS.reduce((details, key) => {
        details[key] = null
        return details
    }, {})
}

// the details of a log, null for the ones it has not
export function shotDetailsOf(log) {
    return SHOT_DETAIL_KEYS.reduce((details, key) => {
        details[key] = (log && log[key]) || null
        return details
    }, {})
}

export function hasShotDetails(details) {
    return !!details && SHOT_DETAIL_KEYS.some(key => details[key])
}

// e.g. "Fastbreak · Drive / Isolation · Layup / Rim finish" for the feed
export function describeShotDetails(details) {
    return SHOT_DETAIL_GROUPS
        .map(group => {
            const option = group.options.find(item => item.value === (details && details[group.key]))
            return option ? option.label : null
        })
        .filter(Boolean)
        .join(' · ')
}
